import { useCallback, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { CargarClienteComponent, ClientesListado, Header } from "../../components";
import { ROLES } from "../../constants/roles";
import { useAuthContext } from "../../context/auth";
import "./stylesClienteGestion.scss";

export const CargarCliente = () => {
  const [mostrarCargarCliente, setMostrarCargarCliente] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const { rol } = useAuthContext();
  const puedeEditar = rol !== ROLES.INVERSOR;

  const toggleCargarCliente = () => {
    setMostrarCargarCliente(!mostrarCargarCliente);
  };

  const handleClienteSaved = useCallback(() => {
    setMostrarCargarCliente(false);
    setRefreshKey((k) => k + 1);
  }, []);

  return (
    <div className="clientes-gestion">
      <Modal isOpen={mostrarCargarCliente} toggle={toggleCargarCliente} size="xl" className="modal-agregar-cliente">
        <ModalHeader toggle={toggleCargarCliente}>Agregar Cliente</ModalHeader>
        <ModalBody>
          <CargarClienteComponent onSave={handleClienteSaved} />
        </ModalBody>
      </Modal>
      <ClientesListado
        key={refreshKey}
        renderHeader={(filtersContent) => (
          <Header centerContent={filtersContent}>
            {puedeEditar && (
              <button onClick={toggleCargarCliente} className="boton-agregar-cliente agregar">
                Agregar Cliente
              </button>
            )}
          </Header>
        )}
      />
    </div>
  );
};
